import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Shell } from "@/components/shell";
import { Spinner } from "@/components/kit";
import { Login, Home, Facility } from "@/pages/Main";
import { ReportFormPage, ReportDetail } from "@/pages/Report";
import { Riwayat, Verifikasi, Galeri, Recap, News, PublicReport, PublicNews, PublicRecap, PublicDaily, PublicMonthly, Privacy } from "@/pages/Lists";
import { GantiSandi, Profil, Tim, Fasilitas } from "@/pages/Admin";
import { VideoPage, Tutorial, PublicTutorial, BagikanTim, CardPage } from "@/pages/Media";
import { ImporPage } from "@/pages/Impor";

const CATS = ["kios", "bsi", "pdu", "kompos", "tpa"];

function Private() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading"><Spinner /></div>;
  if (!user) return <Login />;
  if (user.must_change) return <GantiSandi />;
  return (
    <Shell>
      <Routes>
        <Route index element={<Home />} />
        {CATS.map((c) => <Route key={c} path={c} element={<Facility category={c} />} />)}
        <Route path="riwayat" element={<Riwayat />} />
        <Route path="profil" element={<Profil />} />
        <Route path="report/new" element={<ReportFormPage />} />
        <Route path="report/:id" element={<ReportDetail />} />
        <Route path="verifikasi" element={<Verifikasi />} />
        <Route path="galeri" element={<Galeri />} />
        <Route path="recap" element={<Recap />} />
        <Route path="news" element={<News />} />
        <Route path="video" element={<VideoPage />} />
        <Route path="tutorial" element={<Tutorial />} />
        <Route path="bagikan-tim" element={<BagikanTim />} />
        <Route path="card" element={<CardPage />} />
        <Route path="fasilitas" element={<Fasilitas />} />
        <Route path="tim" element={<Tim />} />
        <Route path="akun" element={<Tim manage />} />
        <Route path="impor-tpa" element={<ImporPage kind="tpa" />} />
        <Route path="impor-bsi" element={<ImporPage kind="bsi" />} />
        <Route path="impor-kios" element={<ImporPage kind="kios" />} />
        <Route path="impor-pdu" element={<ImporPage kind="pdu" />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Shell>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/publik/laporan/:token" element={<PublicReport />} />
          <Route path="/publik/news" element={<PublicNews />} />
          <Route path="/publik/news/:slug" element={<PublicNews />} />
          <Route path="/publik/rekap/:year" element={<PublicRecap />} />
          <Route path="/publik/harian/:tanggal" element={<PublicDaily />} />
          <Route path="/publik/bulanan/:ym" element={<PublicMonthly />} />
          <Route path="/publik/tutorial/:id" element={<PublicTutorial />} />
          <Route path="/kebijakan-privasi" element={<Privacy />} />
          <Route path="/*" element={<Private />} />
        </Routes>
      </AuthProvider>
      <Toaster richColors position="top-center" />
    </BrowserRouter>
  );
}
